import(/* webpackMode: "eager", webpackExports: ["FaqSectionWithCategories"] */ "/vercel/path0/apps/web/src/components/blocks/faq-with-categories.tsx");
